import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaInstagram, FaFacebook, FaWhatsapp, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import { MdArrowForward } from 'react-icons/md';

const Footer = () => {
    const { t } = useTranslation();
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-gray-900 text-white mt-auto relative overflow-hidden border-t border-gray-800">
            {/* Decorative Background Elements */}
            <div className="absolute inset-0 opacity-10 pointer-events-none">
                <div className="absolute top-0 right-0 w-96 h-96 bg-primary rounded-full filter blur-3xl transform translate-x-1/3 -translate-y-1/3"></div>
                <div className="absolute bottom-0 left-0 w-96 h-96 bg-secondary rounded-full filter blur-3xl transform -translate-x-1/3 translate-y-1/3"></div>
            </div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16 relative z-10">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 text-center md:text-left">
                    {/* About Section */}
                    <div className="space-y-6">
                        <img
                            src="/shreelogo.png"
                            alt="Choundeshwari Credit Society"
                            className="h-16 w-auto mb-6 hover:scale-105 transition-transform duration-300 mx-auto md:mx-0 bg-white/90 p-2 rounded-lg"
                        />
                        <p className="text-gray-400 text-sm leading-relaxed">
                            {t('footer.tagline_text')}
                        </p>
                        {/* Social Media Icons */}
                        <div className="flex space-x-4 pt-4 justify-center md:justify-start">

                            <a
                                href="https://www.instagram.com/shreechoundeshwaripatsanstha/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-10 h-10 bg-gray-800 hover:bg-[#E1306C] text-gray-400 hover:text-white rounded-full flex items-center justify-center transition-all duration-300 transform hover:scale-110 shadow-lg"
                                aria-label="Instagram"
                            >
                                <FaInstagram className="text-xl" />
                            </a>
                            <a
                                href="https://www.facebook.com/shreechoundeshwaripatsanstha/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-10 h-10 bg-gray-800 hover:bg-[#1877F2] text-gray-400 hover:text-white rounded-full flex items-center justify-center transition-all duration-300 transform hover:scale-110 shadow-lg"
                                aria-label="Facebook"
                            >
                                <FaFacebook className="text-xl" />
                            </a>
                            <a
                                href="https://wa.me/919823162163"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-10 h-10 bg-gray-800 hover:bg-[#25D366] text-gray-400 hover:text-white rounded-full flex items-center justify-center transition-all duration-300 transform hover:scale-110 shadow-lg"
                                aria-label="WhatsApp"
                            >
                                <FaWhatsapp className="text-xl" />
                            </a>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="text-lg font-bold mb-6 text-white relative inline-block">
                            {t('footer.quick_links_title')}
                            <span className="absolute bottom-0 left-1/2 -translate-x-1/2 md:left-0 md:translate-x-0 w-12 h-1 bg-primary rounded-full mt-2"></span>
                        </h3>
                        <ul className="space-y-3">
                            <li>
                                <Link to="/about" className="text-gray-400 hover:text-primary transition-all duration-300 flex items-center justify-center md:justify-start group">
                                    <MdArrowForward className="mr-2 text-primary opacity-0 group-hover:opacity-100 -ml-4 group-hover:ml-0 transition-all duration-300" />
                                    {t('footer.about')}
                                </Link>
                            </li>
                            <li>
                                <Link to="/vision-mission" className="text-gray-400 hover:text-primary transition-all duration-300 flex items-center justify-center md:justify-start group">
                                    <MdArrowForward className="mr-2 text-primary opacity-0 group-hover:opacity-100 -ml-4 group-hover:ml-0 transition-all duration-300" />
                                    {t('footer.visionMission')}
                                </Link>
                            </li>
                            <li>
                                <Link to="/branches" className="text-gray-400 hover:text-primary transition-all duration-300 flex items-center justify-center md:justify-start group">
                                    <MdArrowForward className="mr-2 text-primary opacity-0 group-hover:opacity-100 -ml-4 group-hover:ml-0 transition-all duration-300" />
                                    {t('footer.branches')}
                                </Link>
                            </li>
                            <li>
                                <Link to="/contact" className="text-gray-400 hover:text-primary transition-all duration-300 flex items-center justify-center md:justify-start group">
                                    <MdArrowForward className="mr-2 text-primary opacity-0 group-hover:opacity-100 -ml-4 group-hover:ml-0 transition-all duration-300" />
                                    {t('footer.contact')}
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Services */}
                    <div>
                        <h3 className="text-lg font-bold mb-6 text-white relative inline-block">
                            {t('footer.services')}
                            <span className="absolute bottom-0 left-1/2 -translate-x-1/2 md:left-0 md:translate-x-0 w-12 h-1 bg-primary rounded-full mt-2"></span>
                        </h3>
                        <ul className="space-y-3">
                            <li>
                                <Link to="/deposits" className="text-gray-400 hover:text-primary transition-all duration-300 flex items-center justify-center md:justify-start group">
                                    <MdArrowForward className="mr-2 text-primary opacity-0 group-hover:opacity-100 -ml-4 group-hover:ml-0 transition-all duration-300" />
                                    {t('footer.deposits')}
                                </Link>
                            </li>
                            <li>
                                <Link to="/loans" className="text-gray-400 hover:text-primary transition-all duration-300 flex items-center justify-center md:justify-start group">
                                    <MdArrowForward className="mr-2 text-primary opacity-0 group-hover:opacity-100 -ml-4 group-hover:ml-0 transition-all duration-300" />
                                    {t('footer.loans')}
                                </Link>
                            </li>
                            <li>
                                <Link to="/careers" className="text-gray-400 hover:text-primary transition-all duration-300 flex items-center justify-center md:justify-start group">
                                    <MdArrowForward className="mr-2 text-primary opacity-0 group-hover:opacity-100 -ml-4 group-hover:ml-0 transition-all duration-300" />
                                    {t('footer.careers')}
                                </Link>
                            </li>
                            <li>
                                <Link to="/member-services" className="text-gray-400 hover:text-primary transition-all duration-300 flex items-center justify-center md:justify-start group">
                                    <MdArrowForward className="mr-2 text-primary opacity-0 group-hover:opacity-100 -ml-4 group-hover:ml-0 transition-all duration-300" />
                                    {t('footer.memberServices')}
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h3 className="text-lg font-bold mb-6 text-white relative inline-block">
                            {t('footer.contact')}
                            <span className="absolute bottom-0 left-1/2 -translate-x-1/2 md:left-0 md:translate-x-0 w-12 h-1 bg-primary rounded-full mt-2"></span>
                        </h3>
                        <div className="space-y-4">
                            <div className="flex items-start space-x-3 justify-center md:justify-start group">
                                <div className="p-2 bg-gray-800 rounded-lg group-hover:bg-primary/20 transition-colors duration-300">
                                    <FaMapMarkerAlt className="text-primary mt-1 flex-shrink-0" />
                                </div>
                                <p className="text-gray-400 text-sm leading-relaxed max-w-xs">{t('footer.address')}</p>
                            </div>
                            <div className="flex items-center space-x-3 justify-center md:justify-start group">
                                <div className="p-2 bg-gray-800 rounded-lg group-hover:bg-primary/20 transition-colors duration-300">
                                    <FaPhoneAlt className="text-primary flex-shrink-0" />
                                </div>
                                <a href={`tel:${t('footer.phone')}`} className="text-gray-400 text-sm hover:text-white transition-colors duration-300">
                                    {t('footer.phone')}
                                </a>
                            </div>
                            <div className="flex items-center space-x-3 justify-center md:justify-start group">
                                <div className="p-2 bg-gray-800 rounded-lg group-hover:bg-primary/20 transition-colors duration-300">
                                    <FaEnvelope className="text-primary flex-shrink-0" />
                                </div>
                                <p className="text-gray-400 text-sm hover:text-white transition-colors duration-300 cursor-pointer break-all">{t('footer.email')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="border-t border-gray-800 bg-gray-950/50 relative z-10">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
                        <p className="text-gray-500 text-sm text-center md:text-left hover:text-gray-300 transition-colors duration-300">
                            &copy; {currentYear} {t('footer.copyright')}
                        </p>
                        <p className="text-gray-500 text-sm text-center">
                            {t('footer.developedBy')}{' '}
                            <a
                                href="https://digisahyadri.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="hover:text-white transition-colors duration-300 font-semibold group ml-1"
                            >

                                <span className="text-white">DigiSahyadri</span>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
